import {setInitialState} from '../../../../utils/reducerOperations';

export const InitialState=()=>({
    fetchExploreOutliersDataApi:setInitialState(),
    isOutliersDataAlreadyFetched:false,
    filters:{},
    selectedUser : "",
    directReporteesOnly: false
});